export default "/images/underline.svg?0d7736c892eca6eafefef0013e8ae1dd";